import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'purple';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'w-full py-4 px-6 rounded-[1.35rem] font-display tracking-wide text-xl transition-all duration-200 flex items-center justify-center focus:outline-none focus:ring-4 focus:ring-brand-purple/25 disabled:opacity-70 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-brand-purple text-white hover:bg-brand-purple-dark shadow-[0_6px_0_#4932C9] hover:shadow-[0_3px_0_#4932C9] hover:translate-y-1 active:shadow-none active:translate-y-2',
    purple: 'bg-brand-purple text-white hover:bg-brand-purple-dark shadow-[0_6px_0_#4932C9] hover:shadow-[0_3px_0_#4932C9] hover:translate-y-1 active:shadow-none active:translate-y-2',
    secondary: 'bg-brand-yellow text-brand-navy hover:bg-brand-yellow-dark shadow-[0_6px_0_#E6B800] hover:shadow-[0_3px_0_#E6B800] hover:translate-y-1 active:shadow-none active:translate-y-2',
    ghost: 'bg-transparent text-brand-purple hover:bg-brand-purple/10'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-781" data-mp="onat1plvzjcd">
      {isLoading ? <>
          <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-782" data-mp="xoieh73b0pp1" />
          WAIT...
        </> : children}
    </button>;
}